import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["publicKey", "encryptedDataInput", "input"];

  connect() {
    const numberInput = this.inputTargets.find((el) => el.id === "number");
    numberInput.oninvalid = function(event) {
      event.target.setCustomValidity('Card number can only contain numbers and must from 13 to 19 digits long');
    }
    numberInput.oninput = function(event) {
      event.target.setCustomValidity('');
    }

    const cvvInput = this.inputTargets.find((el) => el.id === "security_code");
    cvvInput.oninvalid = function(event) {
      event.target.setCustomValidity('Security code can only contain numbers');
    }
    cvvInput.oninput = function(event) {
      event.target.setCustomValidity('');
    }
  }

  async encrypt(event) {
    if (this.element.hasAttribute("data-processed")) {
      return true;
    }
    event.preventDefault();

    const cryptoKey = await crypto.subtle.importKey(
      "spki",
      this.#unpack(this.publicKey),
      {
        name: "RSA-OAEP",
        modulusLength: 4096,
        publicExponent: new Uint8Array([1, 0, 1]), // 65537
        hash: "SHA-256",
      },
      false,
      ["encrypt"],
    );

    var encryptedData = await crypto.subtle.encrypt(
      {
        name: "RSA-OAEP",
      },
      cryptoKey,
      this.#encode(this.jsonFormData),
    );

    const packedEncryptedData = this.#pack(encryptedData);
    this.encryptedDataInputTarget.value = packedEncryptedData;

    const last4CardDigitsInput = this.inputTargets.find((el) => el.id === "lease_response_last_4_card_digits");
    if(last4CardDigitsInput) {
      last4CardDigitsInput.value = this.inputTargets.find((el) => el.id === "number").value.slice(-4);
    }

    this.element.setAttribute("data-processed", "true");
    this.element.submit();
    this.element.reset();
  }

  get publicKey() {
    return this.publicKeyTarget.value;
  }
  get jsonFormData() {
    const formElements = this.inputTargets;
    const formData = Array.from(formElements).map((el) => [el.id, el.value]);
    const formObject = Object.fromEntries(formData);
    return JSON.stringify(formObject);
  }

  #pack(buffer) {
    // https://developers.google.com/web/updates/2012/06/How-to-convert-ArrayBuffer-to-and-from-String
    return window.btoa(String.fromCharCode.apply(null, new Uint8Array(buffer)));
  }

  #unpack(packed) {
    // https://developers.google.com/web/updates/2012/06/How-to-convert-ArrayBuffer-to-and-from-String
    const string = window.atob(packed);
    const buffer = new ArrayBuffer(string.length);
    const bufferView = new Uint8Array(buffer);

    for (let i = 0; i < string.length; i++) {
      bufferView[i] = string.charCodeAt(i);
    }

    return buffer;
  }

  #encode(data) {
    // https://developer.mozilla.org/en-US/docs/Web/API/TextEncoder
    const encoder = new TextEncoder();

    return encoder.encode(data);
  }
}
